/**
 * SettingsLinkMoveDirection
 */
export enum SettingsLinkMoveDirection {
    UP = 'up',
    DOWN = 'down'
}
